import { cn } from '@workspace/ui/lib/utils'

interface RoleSelectCardProps {
  choices: { label: string; value: string; description?: string }[]
  resolved?: boolean
  selectedValue?: string
  onSelect: (value: string) => void
}

export function RoleSelectCard({
  choices,
  resolved,
  selectedValue,
  onSelect,
}: RoleSelectCardProps) {
  return (
    <div className="flex min-w-[220px] flex-col gap-2">
      {choices.map((choice) => {
        const isSelected = selectedValue === choice.value
        const isDisabled = resolved && !isSelected

        return (
          <button
            key={choice.value}
            type="button"
            disabled={resolved}
            onClick={() => !resolved && onSelect(choice.value)}
            className={cn(
              'w-full rounded-xl border-2 p-4 text-left transition-all',
              isSelected
                ? 'border-[#f97316] bg-[#f97316]/10'
                : 'border-border bg-card hover:border-[#f97316]/50',
              isDisabled && 'opacity-40'
            )}
          >
            <p className="text-sm font-medium text-white">{choice.label}</p>
            {choice.description && (
              <p className="mt-1 text-xs text-muted-foreground">{choice.description}</p>
            )}
          </button>
        )
      })}
    </div>
  )
}
